// @ts-nocheck
import { Component } from 'react';
// CUSTOM
// @ts-ignore
import { sendData } from '../../../../webjam/websocket';
// @ts-ignore
import { SaveLog } from '../../../../customise/Utils';
/**
 * Abstract React {@code Component} for tabs of the DialogWithTabs component.
 *
 * @augments Component
 */
class AbstractDialogTab extends Component {
    /**
     * Initializes a new {@code AbstractDialogTab} instance.
     *
     * @param {P} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        // Bind event handler so it is only bound once for every instance.
        this._onChange = this._onChange.bind(this);
    }
    /**
     * Uses the onTabStateChange function to pass the changed state of the
     * controlled tab component to the controlling DialogWithTabs component.
     *
     * @param {Object} change - Object that contains the changed property and
     * value.
     * @returns {void}
     */
    _onChange(change) {
        // CUSTOM
        const { onTabStateChange, tabId, usersData } = this.props;
        if (usersData && change) {
            var message = {
                action: {
                    firstname: change.displayName,
                    lastname: '',
                    uniqueID: usersData.uniqueId,
                },
                content: 'set-name',
                isBroadcast: true,
                sender: 'mobile',
            };
            //-------------Prepare logger data -------------
            var log_data = {
                functionName: '',
                triggeredBy: 'system',
                event: message.content,
                requestData: message,
                responseData: '',
                userId: '',
                boxId: message.action.uniqueID,
                message: 'Emit to server'
            };
            SaveLog(log_data);
            //-------------------------------------------
            sendData(message, '', 1);
        }
        // END
        onTabStateChange(tabId, {
            ...this.props,
            ...change
        });
    }
}
export default AbstractDialogTab;
